
import React, { Component } from 'react';
import ProductsHelper from './ProductsHelper';
import './products.css'

class Products extends Component {
    constructor(props) {
        super(props);

        // initialize the products  (combination of original products + changes)
        const products = ProductsHelper.Get(this.props.orders, this.props.changes.state);

        this.state = {
            mode: "",
            products: products,
            enableSave: this.props.enableSave
        };
    }

    componentDidMount() {

    }
    goMain() {
        this.setState({ mode: "" });
    }

    showProductSelector() {
        this.setState({ mode: "selectProduct", accordionProducts: "" });
    }

    changeQuantity(item) {
        this.setState({ mode: "changeQuantity", selectedItem: item, editQuantity: item.quantity });
    }

    handleChange(evt) {
        const value = evt.target.value;
        this.setState({ deleteReason: value});
    }

    handleChangeQty(evt) {
        // update the quantity
        const value = evt.target.value;
        this.setState({ editQuantity: value});
    }

    saveQuantity() {
        var value=this.state.editQuantity;
        if (value<1 || value>10) return;
        
        var selectedItem=this.state.selectedItem;
        selectedItem.quantity=value;

        this.setState({ selectedItem: selectedItem.quantity});
        this.goMain();
    }
    
    selectProduct(evt) {
        const value = evt.target.value;
        this.addProduct(value);
    }
    addProduct(value) {
        var item = this.props.selectableProducts.find(p => p.item.code === value);
        item.quantity=1;
        this.props.changes.AddProduct(item);

        this.setState({ mode:"", products: ProductsHelper.Get(this.props.orders, this.props.changes.state) });
    }

    removeProduct(idx) {
        // remove this product from the state, needs to confirm when the product has an ID  (then the product already exists in SAP)
        var products =  [...this.state.products];           // note: new array to prevent immediate changes on state
        var item = products.splice(idx, 1);

        if (item[0].id===null) {
            this.confirmRemoveProduct(idx);
        } else {
            // ask confirmation before
            this.setState({ mode:"confirmDelete", deleteIndex: idx, deleteReason: item[0].item.name + " is van order verwijderd met reden: "});
        }
        
    }
    confirmDelete() {
        // confirmed 
        this.confirmRemoveProduct(this.state.deleteIndex);
        this.setState({mode:""});

        // add as an activity
        const details="Artikel verwijderd vanuit Digibon";
        const notes = this.state.deleteReason;
        this.props.changes.AddActivityNote(details, notes);

        // add to "werkzaamheden"
        this.props.changes.AppendResolution(notes);
        this.props.resolutionUpdated();
        
    }
    confirmRemoveProduct(idx) {
        var products = this.state.products;
        var item = products.splice(idx, 1);
        this.setState({ products: products });
        this.props.changes.RemoveProduct(item[0]);
    }

    resetProducts() {
        this.props.changes.ResetProducts();
        this.setState({ products: ProductsHelper.Get(this.props.orders, this.props.changes.state) });
    }
    selectAccordionProducts(item) {
        if (this.state.accordionProducts === item) {
            this.setState({ accordionProducts: "" });
        } else {
            this.setState({ accordionProducts: item });
        }
    }
    render() {
        const categories = [];

        // generate the options for available products
        this.props.selectableProducts && this.props.selectableProducts.map((item, index) => {
            if (categories.indexOf(item.groupName) === -1) {
                categories.push(item.groupName)
            }

            return true;
        });

        const productsSelector = <div className="accordion" >
            {categories.map((groupName, idx) => {

                return <div className="accordion-item" key={idx}>
                    <h2 className="accordion-header">
                        <button className={this.state.accordionProducts === groupName ? "accordion-button" : "accordion-button collapsed"} type="button" onClick={p => this.selectAccordionProducts(groupName)}>
                            {groupName}
                        </button>
                    </h2>
                    <div className={this.state.accordionProducts === groupName ? "accordion-collapse collapse show" : "accordion-collapse collapse"}>
                        <div className="accordion-body">
                            {
                                this.props.selectableProducts.filter(p => p.selectable && p.groupName === groupName).map((item, index) => {
                                    const itemCode = item.item.code;
                                    return <div className="row pt-2 pb-2 clickable product hover" key={index} onClick={p => this.addProduct(itemCode)}>
                                        <div className="col-md-3">{item.item.code}</div>
                                        <div className="col">{item.item.name}  </div>
                                        <div className="col-md-2">€ {item.unitPrice.toFixed(2)}</div>
                                    </div>
                                })

                            }
                        </div>
                    </div>
                </div>
            })}
        </div>

        const productsHeader = <b className="d-none d-md-block"><div className="row ">
            <div className="col">Artikel</div>
            <div className="col">Omschrijving</div>
            <div className="col-md-1">Aantal</div>
            <div className="col">Prijs</div>
            {this.state.enableSave &&
                <div className="col-2">Actie</div>
            }
        </div></b>

        // generate the currently selected products
        const products = this.state.products && this.state.products.map((item, index) => {
            return <div className="row" key={index}>
                <div className="col-md"><span className="d-md-none"><b>Artikel:</b></span>{item.item.code}</div>
                <div className="col-md"><span className="d-md-none"><b>Omschrijving:</b></span>{item.item.name}</div>
                <div className="col-md-1"><span className="d-md-none"><b>Aantal:</b></span>
                    {item.isAdded && <span onClick={p=> this.changeQuantity(item)} className="btn btn-secondary">
                        {item.quantity}  
                    </span>}
                    {!item.isAdded && <span>{item.quantity}</span>}

                </div>
                <div className="col-md text-right"><span className="d-md-none"><b>Prijs:</b></span>€ {item.unitPrice.toFixed(2)}</div>
                {this.state.enableSave &&
                    <div className="col-2"><button className="btn btn-danger mb-1" onClick={() => this.removeProduct(index)}>terugnemen</button></div>
                }
            </div>
        });



        return <>
            {this.state.mode === "changeQuantity" &&
                <div>
                    <div className="quantity-back"></div>

                    <div className="quantity-front">

                        Pas het aantal aan  <input className="number" value={this.state.editQuantity} onChange={this.handleChangeQty.bind(this)}></input>

                        <input className="btn ms-2 btn-sm btn-secondary" type="button" value="-" onClick={() =>this.setState({editQuantity:this.state.editQuantity>1 ? this.state.editQuantity-1:1})}/>
                        <input className="btn ms-2 btn-sm btn-secondary" type="button" value="+"  onClick={() =>this.setState({editQuantity:this.state.editQuantity<10 ? this.state.editQuantity+1: 10})}/>
                        <div><button className="btn btn-success" onClick={this.saveQuantity.bind(this)}>ok</button></div>

                    </div>
                </div>
            }

            {this.state.mode === "confirmDelete" &&
                <div>
                    <div className="delete-reason-back"></div>

                    <div className="delete-reason-front">
                        <div>Vul hieronder de tekst aan met de reden op waarom dit product van de order moet worden verwijderd.</div>
                        <textarea className="form-control" value={this.state.deleteReason} onChange={this.handleChange.bind(this)}></textarea>
                        <div className="mt-2">
                            <button className="btn btn-danger" onClick={this.goMain.bind(this)}>cancel</button>
                            <button className="btn btn-success ms-2" onClick={this.confirmDelete.bind(this)}>ok</button>
                        </div>
                        

                    </div>
                </div>
            }



            {this.state.mode === "selectProduct" &&
                <div>
                    <div className="product-select-back"></div>

                    <div className="product-select-front">

                        <div className="overflow-auto fill pt-4">
                            <br /><br />
                            {productsSelector}
                        </div>
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.goMain.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                    </div>
                </div>
            }

            {this.state.mode === "" &&
                <div >
                    {this.state.products && <React.Fragment>{productsHeader}{products}</React.Fragment>
                    }
                    {this.state.enableSave && this.state.products.length === 0 && <div className="text-danger">
                        <i className="fa-solid fa-triangle-exclamation text-danger"></i>  Er zijn op dit moment geen artikelen geselecteerd. Er moet minimaal 1 artikel op de bon staan.
                    </div>}
                    {this.state.enableSave &&
                        <button className="btn btn-success" onClick={this.showProductSelector.bind(this)}>toevoegen</button>
                    }

                    {this.props.changes.ResetProductsEnabled() &&
                        <button className="btn btn-danger ms-4" onClick={this.resetProducts.bind(this)}>reset</button>
                    }
                </div>
            }
        </>
    }
}

export default Products;